import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { Link } from '~/components/Link';
import styles from './ListingCard.module.css';
import type { CardContentProps, CardFooterProps, CardTitleProps, ListingCardProps } from './ListingCard.types';
import { ListingCardGallery } from './ListingCardGallery';
import { ListingCardLoading } from './ListingCardLoading';
import { ListingCardTag } from './ListingCardTag';
const CardLink = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Link isUnstyled={true} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const ListingCardRoot = t0 => {
  const $ = _c(25);
  let children;
  let fullHeight;
  let fullWidth;
  let isLoading;
  let isSelected;
  let rest;
  let t1;
  let t2;
  let t3;
  let variant;
  if ($[0] !== t0) {
    ({
      layout: t1,
      hasBackground: t2,
      variant,
      isClickable: t3,
      isSelected,
      fullWidth,
      fullHeight,
      isLoading,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = fullHeight;
    $[3] = fullWidth;
    $[4] = isLoading;
    $[5] = isSelected;
    $[6] = rest;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = variant;
  } else {
    children = $[1];
    fullHeight = $[2];
    fullWidth = $[3];
    isLoading = $[4];
    isSelected = $[5];
    rest = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    variant = $[10];
  }
  const layout = t1 === undefined ? "vertical" : t1;
  const hasBackground = t2 === undefined ? true : t2;
  const isClickable = t3 === undefined ? true : t3;
  const t4 = layout === "horizontal";
  const t5 = !hasBackground;
  let t6;
  if ($[11] !== fullHeight || $[12] !== fullWidth || $[13] !== isClickable || $[14] !== isLoading || $[15] !== isSelected || $[16] !== t4 || $[17] !== t5) {
    t6 = clsx(styles.container, {
      [styles.layoutHorizontal]: t4,
      [styles.noBackground]: t5,
      [styles.clickable]: isClickable,
      [styles.selected]: isSelected,
      [styles.fullWidth]: fullWidth,
      [styles.fullHeight]: fullHeight,
      [styles.loading]: isLoading
    });
    $[11] = fullHeight;
    $[12] = fullWidth;
    $[13] = isClickable;
    $[14] = isLoading;
    $[15] = isSelected;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const containerClassName = t6;
  let t7;
  if ($[19] !== children || $[20] !== containerClassName || $[21] !== isLoading || $[22] !== rest || $[23] !== variant) {
    t7 = <div data-test-id="ListingCard" data-card-variant={variant} aria-busy={isLoading} className={containerClassName} {...rest}>{children}</div>;
    $[19] = children;
    $[20] = containerClassName;
    $[21] = isLoading;
    $[22] = rest;
    $[23] = variant;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};
const CardContent = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div data-card-content={true} data-test-id="CardContent" className={styles.content}>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const CardFooter = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div data-card-footer={true} data-test-id="CardFooter" className={styles.footer}>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const CardTitle = t0 => {
  const $ = _c(12);
  let children;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      as: t1,
      lineClamp: t2,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
  } else {
    children = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const Tag = t1 === undefined ? "h3" : t1;
  const lineClamp = t2 === undefined ? 2 : t2;
  let t3;
  if ($[5] !== lineClamp) {
    t3 = lineClamp !== 2 && {
      style: {
        WebkitLineClamp: lineClamp
      }
    };
    $[5] = lineClamp;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== Tag || $[8] !== children || $[9] !== rest || $[10] !== t3) {
    t4 = <Tag data-test-id="CardTitle" className={styles.title} {...rest} {...t3}>{children}</Tag>;
    $[7] = Tag;
    $[8] = children;
    $[9] = rest;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const ListingCard = Object.assign(ListingCardRoot, {
  Gallery: ListingCardGallery,
  Content: CardContent,
  Footer: CardFooter,
  Title: CardTitle,
  Tag: ListingCardTag,
  Loading: ListingCardLoading,
  Link: CardLink
});
export type { CardGalleryDatoImage, CardGalleryImage, CardGalleryProps, CardGallerySource, CardTitleProps, CardTitleTag, ListingCardLayout, ListingCardProps, ListingCardVariant } from './ListingCard.types';